import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as artifactActions from '~/artifact/actions';
import * as expandableSectionActions from '~/actions/expandableSection';
import ArtifactViewMainContentVulnerableMethods from '~/artifact/containers/ArtifactViewMainContentVulnerableMethods';
import ArtifactViewMainContentFixInfo from '~/artifact/containers/ArtifactViewMainContentFixInfo';
import ArtifactViewMainContentSignatures from '~/artifact/components/ArtifactViewMainContentSignatures';
import { vulnSectionsMap } from '~/constants/ModelConstants';
type ArtifactViewMainContentLibraryInformationProps = {
  actions: object;
  artifactState: object;
  expandableSectionState: object;
  artifact: object;
  paywalledContent?: any[];
};
class ArtifactViewMainContentLibraryInformation extends React.Component<
  ArtifactViewMainContentLibraryInformationProps,
  {}
> {
  render() {
    const { artifact = {}, paywalledContent = [] } = this.props;
    const headerStyle =
      'font--14 text--bold pv- color--white-light bo-rad--3 p- bg-color--muted mb';
    return (
      <div>
        {!paywalledContent.includes(vulnSectionsMap.LIBRARY_FIX_INFORMATION) && (
          <div>
            <div className={headerStyle}>{vulnSectionsMap.LIBRARY_FIX_INFORMATION}</div>
            <div className="col-1-1 bo-b--1 border-color--muted-light pb+ mb-">
              <ArtifactViewMainContentFixInfo artifact={artifact} />
            </div>
          </div>
        )}

        {!paywalledContent.includes(vulnSectionsMap.VULNERABLE_METHODS) && (
          <div>
            <div className={headerStyle}>{vulnSectionsMap.VULNERABLE_METHODS}</div>
            <div className="col-1-1 bo-b--1 border-color--muted-light pt pb+ mb-">
              <ArtifactViewMainContentVulnerableMethods />
            </div>
          </div>
        )}

        {!paywalledContent.includes(vulnSectionsMap.LIBRARY_SIGNATURES) && (
          <div>
            <div className={headerStyle}>{vulnSectionsMap.LIBRARY_SIGNATURES}</div>
            <div className="col-1-1 pt pb+ mb-">
              <ArtifactViewMainContentSignatures />
            </div>
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    expandableSectionState: state.expandableSectionState,
    myState: state.myState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...artifactActions, ...expandableSectionActions }, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentLibraryInformation);
